"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ProductDescription = _ref => {
  let {
    prefix,
    description,
    className
  } = _ref;
  if (!description) return null;
  return _react.default.createElement("span", {
    className: `${prefix}price-module__description`
  }, description);
};
ProductDescription.defaultProps = {
  prefix: ''
};
var _default = ProductDescription;
exports.default = _default;